import * as React from 'react';

import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import ComplexCollectionModule from 'bundles/page-config-common/components/shared/ComplexCollectionModule';
import type { PageConfig_ComponentConfig_PageConfig_MostPopularFreeBySkillCollection_Fragment as MostPopularFreeBySkillCollection } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

import _t from 'i18n!nls/search-common';

type Props = {
  pageConfigComponent: MostPopularFreeBySkillCollection;
};

function MostPopularFreeBySkillsCollectionModuleRenderer(props: Props) {
  const { collectionEntity: collection, filters } = props.pageConfigComponent;
  if (!collection?.__typename || collection.__typename !== 'Recommendation_Collection') return null;
  const editLink = {
    text: _t('Edit skills'),
    onboardingQuestionId: QUESTION_IDS.skillSelect,
  };
  return <ComplexCollectionModule collection={collection} filters={filters} cta={editLink} />;
}

export default MostPopularFreeBySkillsCollectionModuleRenderer;
